import React, { useState, useEffect } from 'react'
import BookButton from './BookButton'
import { HashLink as Link } from 'react-router-hash-link';

function Coaching({coaching, focus}) {
  const [highlightFocus, setHighlightFocus] = useState(null); // Track highlight state

  // Debounce function to prevent rapid updates
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  // Update highlightFocus based on hash or scroll
  const updateHighlightFocus = debounce(() => {
    const hash = window.location.hash;
    if (hash === '#onlineCoachingInfo') {
      setHighlightFocus('online');
    } else if (hash === '#inPersonCoachingInfo') {
      setHighlightFocus('inPerson');
    } else {
      setHighlightFocus(null);
    }
  }, 0); // 100ms delay

  // Handle hash changes and scroll events
  useEffect(() => {
    // Initial check on mount
    updateHighlightFocus();

    // Listen for hash changes
    window.addEventListener('hashchange', updateHighlightFocus);

    // Listen for scroll events to catch navigation
    window.addEventListener('scroll', updateHighlightFocus);

    return () => {
      window.removeEventListener('hashchange', updateHighlightFocus);
      window.removeEventListener('scroll', updateHighlightFocus);
    };
  }, []);

  // Handle mouse enter to highlight a section
  const handleMouseEnter = (section) => {
    setHighlightFocus(section);
  };

  // Reset highlight when leaving either section
  const handleMouseLeave = () => {
    setHighlightFocus(null); // Reset to highlight both sections
  };

  return (
    <div id="coaching" style={{ backgroundImage: `url(${coaching.img_url})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <div className='text-white w-full backdrop-brightness-50'>
        <div className='flex flex-col lg:flex-row'>
          {/* Left Side: 1-1 In-Person Training */}
          <div id='inPersonCoachingInfo'
            className={`pt-10 w-full lg:w-1/2 lg:border-r-2 lg:border-white transition-all duration-300 flex-1 ${
              highlightFocus === 'online' ? 'opacity-50 brightness-75' : 'opacity-100 brightness-100'
            }`}
            onMouseEnter={() => handleMouseEnter('inPerson')}
            onMouseLeave={handleMouseLeave}
            >
            <div className='mx-10'>
              <h2 className='text-center font-bold text-xl mb-5'>Home Coaching</h2>
              <p className='mb-4 max-w-md mx-auto'>
              Get personalized fitness coaching at home. I bring the materials, expert guidance, and motivation you need to reach your goals, right to your doorstep.</p>
              <div className='flex-grow' style={{ minHeight: '0.5rem' }}></div>
              <ul className='leading-8 mb-4 list-none max-w-md mx-auto'>
                {coaching.homeCoachingBulletPoints.map((item, index) => (
                  <li key={index} className="ml-5 flex items-start">
                    <svg className="w-5 h-5 mt-1 text-white mr-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"></path>
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div id="onlineCoachingInfo"></div>
          {/* <div className="lg:hidden w-full border-t-2 border-white my-4"></div> */}
          <div className="lg:hidden w-2/3 border-t-2 border-white my-4 mx-auto"></div>
          {/* Right Side: Online Coaching */}
          <div
            className={`pt-10 w-full lg:w-1/2 lg:border-l-2 lg:border-white transition-all duration-300 flex-1 ${
              highlightFocus === 'inPerson' ? 'opacity-50 brightness-75' : 'opacity-100 brightness-100'
            }`}
            onMouseEnter={() => handleMouseEnter('online')}
            onMouseLeave={handleMouseLeave}
            >
            <div className='mx-10'>
              <h2 className='text-center font-bold text-xl mb-5'>Online Coaching</h2>
              <p className='mb-4 max-w-md mx-auto'>
              Experience 1-on-1 online coaching with direct support throughout your fitness journey. Your program will be fully tailored to you for optimal results.</p>
              <div className='flex-grow' style={{ minHeight: '0.5rem' }}></div>
              <ul className='leading-8 mb-4 list-none max-w-md mx-auto'>
                {coaching.onlineCoachingBulletPoints.map((item, index) => (
                  <li key={index} className="ml-5 flex items-start">
                    <svg className="w-5 h-5 mt-1 text-white mr-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"></path>
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className='mt-5 text-center pb-10'>
          <p className='mx-5'>Apply for a FREE call first to see how we can work together.</p>
          <div className='mt-4'>
            <Link to="/#contact" className="inline-block">
              <BookButton text="Apply Now" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Coaching
